import React, { useState } from 'react'
import { observer } from 'mobx-react'
import { CouponItem, Icon } from '@cps'
import classNames from 'classnames'
import { useHistoryNew } from '@utils'
import './index.scss'

/** 盲盒待打开 */
import randomBoxImg from '@img/mkt/groupBuy/randomBoxImg.png'
/** 盲盒已打开 */
import randomBoxOpenImg from '@img/mkt/groupBuy/randomBoxOpenImg.png'
/** 福袋 */
import luckyBagImg from '@img/mkt/groupBuy/luckyBagImg.png'
/** 背景星星 */
import starBg from '@img/mkt/groupBuy/starBg.png'
/** 背景星星打开状态 */
import starOpenBg from '@img/mkt/groupBuy/starOpenBg.png'

interface IProps {
  coupons: any[];
  couponMap: any;
  /** 团购券类型 randomBox 盲盒 luckyBag 福袋 */
  productType: string;
  onClose: () => void;
}

/** 餐品等待时间，等待单数 */
const GroupBuyBox: React.FC<IProps> = (props) => {
  const history = useHistoryNew()
  const { coupons, couponMap, productType, onClose } = props
  const [currentIndex, setCurrentIndex] = useState<number>(0)
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const onLoadImg = () => {
    setTimeout(() => {
      setIsOpen(true)
    }, 1000)
  }
  const handleToMenu = () => {
    history.replace('/menu')
  }
  return (
    <div className='order-groupbuy-prize-box-container'>
      <div className='order-groupbuy-prize-box-wrapper'>
        <div className='order-groupbuy-prize-top-wrapper'>
          <div className={classNames('bag-img-wrapper', productType)}>
            {
              productType === 'randomBox' ? (
                <div>
                  <img src={randomBoxImg} onLoad={onLoadImg} className={classNames('bag-img no-open-img', productType, { hide: isOpen })} />
                  <img src={randomBoxOpenImg} className={classNames('bag-img open-img', { show: isOpen })} />
                </div>
              ) : (
                <div>
                  <img src={luckyBagImg} onLoad={onLoadImg} className={classNames('bag-img no-open-img', productType, { hide: isOpen })} />
                  <img src={luckyBagImg} className={classNames('bag-img open-img', { show: isOpen })} />
                </div>
              )
            }
            <img src={starBg} className={classNames('star-bg-img no-open-img', { hide: isOpen })} />
            <img src={starOpenBg} className={classNames('star-bg-img open-img', { show: isOpen })} />
          </div>
        </div>
        <div className={classNames('order-groupbuy-prize-modal-wrapper', { open: isOpen })}>
          <div className='coupon-list-wrapper'>
            <div className='coupon-tab-wrapper'>
              {coupons?.map((coupon, index: number) => (
                <div
                  key={`title_${index}`}
                  className={classNames('coupon-tab-item', { active: currentIndex === index })}
                  onClick={() => setCurrentIndex(index)}
                >
                  {coupon.productName}
                </div>
              ))}
            </div>
            <div className='groupbuy-coupon-item-wrapper'>
              {
                coupons?.[currentIndex]?.coupons?.map((coupon) => {
                  const couponInfo = couponMap[coupon.couponId]
                  return (
                    <div key={coupon.couponId} className='coupon-item'>
                      <CouponItem type='get' couponInfo={couponInfo} />
                    </div>
                  )
                })
              }
            </div>
          </div>
          <div className='use-btn' onClick={handleToMenu}>{i18n.t('mkt.market.groupBuyUseCoupon')}</div>
        </div>
        {
          isOpen && (
            <div className='close-btn' onClick={onClose}>
              <Icon name='close' />
            </div>
          )
        }
      </div>
    </div>
  )
}

export default observer(GroupBuyBox)
